import { Capacitor } from "@capacitor/core";
import { lazy } from "react";

import Suspense from "components/shared/Suspense";
import useMount from "hooks/useMount";

const MobileManager = lazy(() => import("./MobileManager"));

export default function MobileManagerWrapper() {
  const isNative = Capacitor.isNativePlatform();
  const mounted = useMount();

  if (!mounted || !isNative) {
    return false;
  }

  return (
    <Suspense>
      <MobileManager />
    </Suspense>
  );
}
